export default [
  {
    path: 'targeted-letters',
    name: 'targeted-letters',
    component: () => import('@/views/pages/targeted-letters/Inbox.vue'),
    meta: {
      pageTitle: 'Maqsadli xatlar',
      breadcrumb: [
        {
          text: 'Maqsadli xatlar',
          active: true,
        },
      ],
      resource: 'TargetedLetter',
    },
  },
  {
    path: 'targeted-letters/:id',
    name: 'targeted-letters-view',
    component: () => import('@/views/pages/targeted-letters/View.vue'),
    meta: {
      pageTitle: 'View',
      breadcrumb: [
        {
          to: { name: 'targeted-letters' },
          text: 'Maqsadli xatlar',
          active: false,
        },
        {
          text: 'View',
          active: true,
        },
      ],
      resource: 'TargetedLetter',
    },
  },
  {
    path: 'targeted-letters/:id/history',
    name: 'targeted-letters-history',
    component: () => import('@/views/pages/targeted-letters/History.vue'),
    meta: {
      pageTitle: 'History',
      breadcrumb: [
        {
          to: { name: 'targeted-letters' },
          text: 'Maqsadli xatlar',
          active: false,
        },
        {
          text: 'History',
          active: true,
        },
      ],
      resource: 'TargetedLetter',
    },
  },
]
